import styled from "styled-components";

export const StyledIframe = styled.iframe`
  width: 100%;
  height: calc(100vh - 60px);
  border: none;
  overflow: hidden;

  @media (max-width: 800px) {
    height: 100vh;
  }
`;
